import { createSelector } from 'reselect'

import { localize } from 'helpers/translator'

const poll_delete_answer_validation_selector = questionId => createSelector(
	[ state => state.poll ],
	pollState => {
		const question = pollState.questions.find(question => question.id === questionId)
		const valid = question.answers.length > 2
		return {
			valid,
			message: valid?null:localize('quiz_answers_minimum'),
		}
	}
)

export default poll_delete_answer_validation_selector
